module.exports = __webpack_public_path__ + "static/media/07.1add01e3.jpg";